import { Chip } from '@material-ui/core';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { translate } from '../../../common/intl';
import { DocumentRevisionStatus } from '../../../state/ducks/documentRevisions/types';
import { FBAutocompleteAsync, FBAutocompleteAsyncOption } from '..';
import { AutocompleteOption } from '../FBAutocompleteAsync/FBAutocompleteAsync.types';
import { FBAffectedLhrSelectionProps } from './FBAffectedLhrSelection.types';
import useStyles from './FBAffectedLhrSelection.styles';
import { withFBAffectedLhrSelection } from './FBAffectedLhrSelection.wrap';

interface AffectedLhrOption {
  displayRevision?: string | number
  precalc?: { lshs_subtitle?: { lhr?: { label?: string }, lot?: { label?: string } } }
}

const getOptionLabel = (option: AutocompleteOption) => {
  const { precalc, displayRevision } = option as unknown as AffectedLhrOption;

  return translate('form.builder.deviation.affected.serial.numbers.lot.display', {
    docId: precalc?.lshs_subtitle?.lhr?.label,
    lot: precalc?.lshs_subtitle?.lot?.label,
    displayRevision,
  });
};

// Only Draft LHRs can be picked (ENC-8805 #17); already selected LHRs keep their chips whatever their status
const filterDraftLhrs = (options: AutocompleteOption[]) => options.filter((option) =>
  (option as unknown as { status?: string }).status === DocumentRevisionStatus.Draft);

const FBAffectedLhrSelection: React.FunctionComponent<FBAffectedLhrSelectionProps> = ({
  isOutput,
  disabled,
  urlValues,
  ...props
}) => {
  const classes = useStyles();

  return (
    <FBAutocompleteAsync
      {...props}
      key={urlValues as unknown as string}
      label="lhrDeviation.affectedLots"
      type="affectedLhrSelection"
      optionId={FBAutocompleteAsyncOption.LHR}
      shouldReloadOnInit={true}
      urlValues={urlValues}
      multiple={true}
      withState
      gutter={false}
      disableChipDelete={disabled}
      getOptionLabel={getOptionLabel}
      filterOptions={filterDraftLhrs}
      renderTags={(options, getTagProps) => options.map((option, index) => (
        <Chip
          label={getOptionLabel(option)}
          deleteIcon={<FontAwesomeIcon icon={regular('trash')} />}
          {...getTagProps({ index })}
        />
      ))}
      {...{ disabled }}
      autoCompleteClasses={{
        root: `${classes.root} ${classes.deleteChip}`,
        inputRoot: classes.inputRoot,
        tag: classes.tag,
        endAdornment: classes.endAdornment,
        popper: classes.popper,
        paper: classes.paper,
        listbox: classes.listbox,
        option: classes.option,
      }}
    />
  );
};

export default withFBAffectedLhrSelection(FBAffectedLhrSelection);
